module.exports = __webpack_public_path__ + "static/media/network_next_violet.db3781a3.svg";